<script>
  import DataTool from "./Tool.svelte";
  import { Theme, FontsUrban, Analytics } from "@urbaninstitute/dataviz-components";
  import appCss from "../../app.css?inline";
  import { onMount } from "svelte";

  let thisHost = $host();

  onMount(() => {
    const shadow = thisHost?.shadowRoot;
    if (!shadow) return;

    // Prevent duplicate injection if component re-initializes
    if (shadow.querySelector("style[data-tailwind-shadow]")) return;

    const styleEl = document.createElement("style");
    styleEl.setAttribute("data-tailwind-shadow", "true");
    styleEl.textContent = appCss;
    shadow.prepend(styleEl);
  });
</script>

<svelte:options customElement={{ tag: "data-tool" }} />

<FontsUrban />
<Analytics title="100 School Districts Segregation Explorer" mode={import.meta.env.MODE} sendPageview={false} />
<Theme>
  <DataTool />
</Theme>
